import { useTranslation } from 'react-i18next'

import { InsuranceForm } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import { useInsuranceCompanies } from 'hooks/useInsuranceCompanies'
import useSaveOnBack from 'hooks/useSaveOnBack'

import usePage from '../../hooks/usePage'

const InsurancePage: React.FC = () => {
  const { onBack, onSubmit, initialValues = {} } = usePage()
  const { data: insuranceCompanies = [] } = useInsuranceCompanies()

  const { t } = useTranslation()
  const formikRef = useSaveOnBack({ onBack })

  return (
    <PageLayout title={t('category.general_information')} subtitle={t('subcategory.insurance_details')}>
      <InsuranceForm
        insuranceCompanies={insuranceCompanies}
        onSubmit={onSubmit}
        innerRef={formikRef}
        initialValues={initialValues}
        loading={false}
      />
    </PageLayout>
  )
}

export default InsurancePage
